"use client";
import React, {useCallback, useEffect, useState} from "react";
import styles from "../redeem.module.css";
import RedeemAccountUtil from "@/app/(redeem)/redeemAccount/RedeemAccountUtil";
import {RedeemAccountUIProps} from "@/app/(redeem)/redeemAccount/RedeemAccountUI";
import WebRedeem from "@/Core/Redeem/WebRedeem";
import BigTips from "@/Master/BigTips";
import EventManager from "@/Fwk/EventManager";
import Util from "@/Master/Util";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import Load from "@/app/_components/Load/Load";

type AccountInfoCardProps = {
    onCallInfo: (a: string, b: string,isOk:boolean) => void,
    data: RedeemAccountUIProps
}

const AccountInfoCard: React.FC<AccountInfoCardProps> = (props) => {
    const {data, onCallInfo} = props;
    const {channelData, channelCheckData} = data;

    const [account, setAccount] = useState('');
    const [cardToken, setCardToken] = useState('');
    const [accountError, setAccountError] = useState('');

    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoadInfoOk, setIsLoadInfoOk] = useState(false);
    const [isOK, setIsOK] = useState<boolean>(false);

    useEffect(() => {
        const {withdrawAccount} = channelCheckData;
        if (withdrawAccount) {
            setAccount(withdrawAccount);
        }

        updateBindCardInfo();
        EventManager.addOnEnterListener(onEnter);
        return () => {
            EventManager.removeOnEnterListener(onEnter);
        };
    }, []);

    const onEnter = () => {
        if (Util.isLog) {
            console.log('AccountInfoCard onEnter', account);
        }
        updateBindCardInfo();
    }

    useEffect(() => {
        onCallInfo(account, cardToken,isOK);
        if (Util.isLog) {
            console.log('AccountInfoCard account Change', account, isOK);
        }
    }, [account, cardToken,isOK]);

    const onAccountChange = (value: string) => {
        setAccount(value);
        if (!value) {
            setAccountError('Please enter your account');
            setIsOK(false);
            return;
        }
        //帐号是否OK
        const accountOk = RedeemAccountUtil.VerifyEmail(value);
        if (!accountOk) {
            setAccountError('Account do not match');
            setIsOK(false);
            return;
        }
        setAccountError('');
        setIsOK(true);
    }

    const openBindCardLink = async () => {
        const {channelType} = channelData;
        showForceLoading();
        const requestRes = await WebRedeem.Instance.RequestBindGetCardsLink(channelType);
        hideForceLoading();
        if (requestRes?.code == 200) {
            const {bindLink, orderNo, userId} = requestRes.data;
            if (Util.isLog) {
                console.log('AccountInfoCards openBindCardLink', requestRes.data)
            }
            window.open(bindLink);
        } else {
            const msg = requestRes?.message || requestRes?.description;
            if (msg) {
                BigTips.showMsg(msg);
            }
        }
    }

    const updateBindCardInfo = async () => {
        const {channelType} = channelData;
        setIsLoadInfoOk(false);
        const requestRes = await WebRedeem.Instance.RequestBindGetCardInfo(channelType);
        setIsLoadInfoOk(true);
        if (requestRes?.code == 200) {
            const {bindResult, cardInfos, orderNo, userId} = requestRes.data;
            if (cardInfos && cardInfos.length > 0){
                const {cardNumber, cardToken} = cardInfos[0];
                setAccount(cardNumber);
                setCardToken(cardToken);
                setIsOK(true);
            }
            if (Util.isLog) {
                console.log('AccountInfoCards getBindCardInfo', requestRes.data);
            }
        } else {
            const msg = requestRes?.message || requestRes?.description;
            if (msg) {
                BigTips.showMsg(msg);
            }
        }
    }

    const hasShowAddBtn = () => {
        if (!isLoadInfoOk) return false;
        if (!account)return true;
        return false;
    }

    const hasShowAccountInfo = () => {
        if (account)return true;
        return false;
    }

    return (
        <>
            {/* 信息输入 */}
            <div className={`${styles.emailBox} ${styles.content}`}>
                <div className={`center ${styles.eTitle}`}>Your Redemption Details</div>
                {
                    hasShowAddBtn() && (
                        <div className={`${styles.cardAddIcon}`} onClick={openBindCardLink}>
                            <img src='/img/redeem/img_add_icon.webp' alt='add_icon'/>
                        </div>
                    )
                }
                {
                    hasShowAccountInfo() ? (
                        <>
                            <div className={styles.inputBox}>
                                <div className={`center ${styles.inputItem}`}>
                                    <div className={styles.inputName}>Account:</div>
                                    <div className={`${styles.input} center`}>
                                        <input
                                            className={styles.form_input}
                                            type='text'
                                            placeholder='Enter Your Account'
                                            value={account}
                                            onChange={e => onAccountChange(e.target.value)}
                                            disabled={isDisabled} // 动态控制 disabled 属性
                                        />
                                        {accountError && <div className={styles.err}>{accountError}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.info}>Please input the correct account and ensure it's
                                activated, or redemption may fail or be delayed.
                            </div>
                        </>
                    ) : (!isLoadInfoOk && <Load/>)
                }


            </div>
        </>
    )
}

export default AccountInfoCard;